require('./style.css');
let tmpl = require('./main.ejs');
let Events = require('f.core.event');
let util = require('f.core.mobile.util');

let formatTime = function(time) {
    if (isNaN(time)) {
        return '00:00:00';
    }
    let second = 0;
    let mintue = 0;
    let hour = 0;
    second = Math.floor(time % 60);
    if (time >= 60) {
        mintue = Math.floor(time / 60);
    }
    if (mintue >= 60) {
        mintue = Math.floor(mintue % 60);
        hour = Math.floor(time / 3600);
    }
    hour = hour < 10 ? '0' + hour : hour;
    second = second < 10 ? '0' + second : second;
    mintue = mintue < 10 ? '0' + mintue : mintue;
    return hour + ':' + mintue + ':' + second;
};

let Control = function(options, isList) {
    this.isList = isList;
    this.options = options;
    this.isHide = false;
    this.init();
    this.hideTimer = null;
};

Control.prototype.init = function() {
    this.initDom();
    this.initEvent();
    this.initZoomState();
};

Control.prototype.initDom = function() {
    let div = document.createElement('div');
    if (this.isList) {
        // 如果是图文直播列表里的视频
        this.isLive = false;
    } else {
        let nowTime = new Date().valueOf();
        if (this.options.start_date > nowTime) {
            // 直播未开始
            this.isLive = '0';
        } else if (nowTime > this.options.end_date) {
            this.isLive = '2'; // 点播
        } else {
            this.isLive = '1';
        }
    }

    div.innerHTML = tmpl({ isLive: this.isLive });
    this.el = div.children[0];
    this.elPlayBtn = this.el.querySelector('.c-video-control__button');
    this.elTimeBar = this.el.querySelector('.c-video-control__timebar');
    this.elTimeBarProgress = this.el.querySelector('.c-video-control__timebar span');
    this.elTimeHandle = this.el.querySelector('.c-video-control__timebar em');
    this.elTimeVal = this.el.querySelector('.c-video-control__time');
    this.elZoom = this.el.querySelector('.c-video-control__zoom');
};

Control.prototype.initEvent = function() {
    let startSwipTime;
    let calTime = function(begin, current) {
        return startSwipTime + (current - begin) / this.timeBarWidth;
    }.bind(this);

    util.tap(
        this.elPlayBtn,
        function() {
            this.trigger('play');
            return false;
        },
        {
            scope: this
        }
    );

    // util.swip(this.el, function () {
    //   clearTimeout(this.hideTimer);
    // }, function () {

    // }, function () {
    //   this.hideTimer = setTimeout(function () {
    //     this.hide();
    //   }.bind(this), 3000);
    // }, {
    //   scope: this
    // });

    util.controllSwip(this.el, function() {}, function() {}, function() {}, {});

    util.controllSwip(
        this.elTimeBar,
        function() {
            clearTimeout(this.hideTimer);
            startSwipTime = this.timeValue;
        },
        function(begin, current, direct) {
            this.setTime(calTime(begin, current), true);
        },
        function(begin, current, direct) {
            this.setTime(calTime(begin, current), true);
            this.hideTimer = setTimeout(
                function() {
                    this.hide();
                }.bind(this),
                3000
            );
            return false;
        },
        {
            scope: this,
            direct: 'horizontal'
        }
    );

    util.tap(
        this.elTimeBar,
        function(e, elm, x, y) {
            let begin = this.elTimeHandle.getBoundingClientRect().left + this.elTimeHandle.offsetWidth / 2;
            this.setTime(calTime(begin, x), true);
            return false;
        }.bind(this)
    );

    util.on(
        window,
        'orientationchange',
        function() {
            this.initZoomState();
            this.resize();
            return false;
        },
        {
            scope: this
        }
    );

    util.tap(
        this.elZoom,
        function() {
            let dge = typeof window.orientation !== 'undefined' ? window.orientation : window.screen.orientation.angle;
            if (Math.abs(dge) == 90) {
                this.trigger('zoom', 'zoomin');
            } else {
                this.trigger('zoom', 'zoomout');
            }
        },
        {
            scope: this
        }
    );
};

Control.prototype.initZoomState = function() {
    let dge = typeof window.orientation !== 'undefined' ? window.orientation : window.screen.orientation.angle;
    if (Math.abs(dge) == 90) {
        $(this.elZoom)
            .removeClass('c-video-control__zoom--zoomin')
            .addClass('c-video-control__zoom--zoomout');
    } else {
        $(this.elZoom)
            .removeClass('c-video-control__zoom--zoomout')
            .addClass('c-video-control__zoom--zoomin');
    }
};

Control.prototype.setTime = function(val, willTrigger) {
    val = val < 0 ? 0 : val > 1 ? 1 : val;

    this.timeBarWidth = this.elTimeBar.offsetWidth - this.elTimeHandle.offsetWidth;
    // this.elTimeHandle.style.marginLeft = this.timeBarWidth * val + 'px';
    $(this.elTimeHandle).css({
        transform: 'translateX(' + this.timeBarWidth * val + 'px)',
        webkitTransform: 'translateX(' + this.timeBarWidth * val + 'px)'
    });
    $(this.elTimeBarProgress).css({
        transform: 'scaleX(' + val + ')',
        webkitTransform: 'scaleX(' + val + ')'
    });
    // this.elTimeBarProgress.style.width = val * 100 + '%';
    this.timeValue = val;

    if (willTrigger) {
        this.trigger('time', val);
    }
};

Control.prototype.setTimeVal = function(timeString) {
    this.elTimeVal.innerHTML = '- ' + formatTime(timeString);
};

Control.prototype.renderTo = function(parentNode) {
    parentNode.appendChild(this.el);
    this.timeBarWidth = this.elTimeBar.offsetWidth - this.elTimeHandle.offsetWidth;
    this.setTime(0, true);
};

Control.prototype.show = function() {
    $(this.el)
        .stop()
        .animate({
            bottom: '0px'
        });
    // this.el.style.visibility = 'visible';
    this.trigger('show');
    this.isHide = false;
    clearTimeout(this.hideTimer);
    this.hideTimer = setTimeout(
        function() {
            this.hide();
        }.bind(this),
        3000
    );
};

Control.prototype.hide = function() {
    $(this.el)
        .stop()
        .animate({
            bottom: '-200px'
        });
    // this.el.style.visibility = 'hidden';
    this.isHide = true;
    this.trigger('hide');
};

Control.prototype.toggle = function() {
    if (this.isHide == true) {
        this.show();
    } else {
        this.hide();
    }
};

Control.prototype.changePlayState = function(type) {
    let types = {
        play: 'c-video-control__button--pause',
        pause: 'c-video-control__button--play'
    };
    this.elPlayBtn.className = 'c-video-control__button ' + types[type];
};

Control.prototype.reset = function() {
    this.elTimeVal.innerHTML = '--';
    this.setTime(0);
    this.changePlayState('pause');
};

Control.prototype.resize = function() {
    this.timeBarWidth = this.elTimeBar.offsetWidth - this.elTimeHandle.offsetWidth;
    this.setTime(this.timeValue);
};

Control.prototype.destory = function() {
    this.off();
    this.el.removeEventListener('click', clickFn);
    this.el.parentNode.removeChild(this.el);
};

Events.mixTo(Control);

module.exports = Control;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.video.mobile/app/modules/recodeControl/index.js